module.exports = __webpack_public_path__ + "img/index_pic5.3b1ee5cf.png";